import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs/internal/Subscription';
import { takeUntil } from 'rxjs/operators';
import {
  isFirmaSubmitLocked,
  isGeneratePdfReady,
  logAutofirmaError,
  releaseFirmaSubmitLock,
} from 'src/app/_helpers/firma-submit.guard';
import { bloquearSiProcedimientoNoActivo } from 'src/app/_helpers/procedimiento-activo.util';
import { bloquearSiTramiteDadoDeBaja, esTramiteBajaSoloConsulta } from 'src/app/_helpers/tramite-baja.util';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ClaveService } from 'src/app/_services/clave.service';
import { ClientFirmaLogService } from 'src/app/_services/client-firma-log.service';
import { CsvgenerateService } from 'src/app/_services/csvgenerate/csvgenerate.service';
import { ProcedimientosService } from 'src/app/_services/procedimientos.service';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { SolicituCustomService } from 'src/app/_services/solicitud-custom.service';
import { SolicitudEmvsService } from 'src/app/_services/solicitud-emvs.service';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { UserService } from 'src/app/_services/user.service';
import { BoardAdminComponent } from 'src/app/board-admin/board-admin.component';
import { NavService } from 'src/app/boton-listado/boton-listado.component.service';
import { ConfirmDeleteDialogComponent } from 'src/app/modal/confirm-delete/confirm-delete-dialog.component';
import { SamlRequest } from 'src/app/model/samltoken';
import { NotificationI18nService } from '../../core/util/notification-i18n.service';
import { ListadoTramitesEmvsService } from './listado-tramites-emvs.service';
import { EstadoTramite, EstadoTramiteReturn, esTramiteDadoDeBaja, TramiteEmvs } from './tramite-emvs';
declare const AutoScript: any;
declare const Constants: any;

export type TramiteDto = {
  "Id": number,
  "Nombre del trámite": string,
  "Fecha": Date,
  "DNI": string,
  "Departamento": string,
  "Estado": string,
  "Acciones": object,
  "Finalizado": boolean,
  "Custom": boolean
};

@Component({
  selector: 'app-listado-tramites-emvs',
  templateUrl: './listado-tramites-emvs.component.html',
  styleUrls: ['./listado-tramites-emvs.component.scss'],
})
export class ListadoTramitesEmvsComponent extends UnsubscribeOnDestroy implements OnInit, OnDestroy {

  displayedColumns: string[] = ["Nombre del trámite", "Fecha", "Estado", "Acciones"];
  adminColumns: string[] = ["DNI"];
  dataSource = new MatTableDataSource<TramiteDto>();
  request: TramiteEmvs[];
  requestCsv: Map<string, any[]>;

  user = this.tokenStorageService.getUser()
  userId = this.user["id"]
  isAdmin: boolean = Math.max(...this.user["rol"]) > 1;
  idCurrentPdf: number = 0;
  tramitesDto: TramiteDto[] = [];
  isInProgress: boolean = false;
  actionProgres: boolean = false;
  firmaResultLocked = false;
  pdfsDownload = [];
  diasCaducidad: string = localStorage.getItem('tramiteMaxDays');
  estadoTramiteReturn = EstadoTramiteReturn;
  esTramiteDadoDeBaja = esTramiteDadoDeBaja;
  esTramiteBajaSoloConsulta = esTramiteBajaSoloConsulta;
  deleteCurrenTramite: TramiteEmvs = {
    id: -1
  }
  selectedTramite: any;
  selectedOpcion: String = 'Firmar con Autofirma';
  subscription: Subscription;
  displayFirma: string = 'none';
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  get totalTramites(): number { return this.dataSource?.data?.length || 0; }
  get tramitesMostrados(): number { return this.dataSource?.filteredData?.length ?? this.totalTramites; }

  puedeEditar(row: TramiteDto, t: any): boolean {
    return !row?.Finalizado
      && t?.estadoFirma !== 'FIRMADO_CON_REGISTRO'
      && t?.estadoFirma !== 'PENDIENTE_DE_FIRMA'
      && !esTramiteDadoDeBaja(t?.estadoFirma);
  }

  puedeDescargar(t: any): boolean {
    return t?.estadoFirma === 'FIRMADO_CON_REGISTRO' || t?.estadoFirma === 'FIRMADO_BAJA_USUARIO';
  }

  puedeEliminar(t: any): boolean {
    return !esTramiteDadoDeBaja(t?.estadoFirma)
      && t?.estadoFirma !== 'FIRMADO_CON_REGISTRO'
      && t?.estadoFirma !== 'RECHAZADA'
      && t?.estadoFirma !== 'RECHAZADO_UNIDAD_FAMILIAR'
      && t?.estadoFirma !== 'PROCESANDO';
  }

  idPdfJustificante(t: any): any {
    return t?.pdfServidor || t?.pdfCliente || t?.id;
  }

  estaDescargando(t: any): boolean {
    return this.isInProgress && this.pdfsDownload.includes(this.idPdfJustificante(t));
  }

  descargarJustificante(t: any): void {
    this.downloadJustificante(this.idPdfJustificante(t));
  }
  mensajeSpinner: string;
  CSV: string;
  constructor(
    private listadoTramitesService: ListadoTramitesEmvsService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private tokenStorageService: TokenStorageService,
    private _csvgenerate: CsvgenerateService,
    private _notificationI18n: NotificationI18nService,
    private _boardAdmin: BoardAdminComponent,
    private _router: Router,
    private _servicioGeneral: ServicioGeneral,
    private _claveService: ClaveService,
    private _navService: NavService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _solicituCustomService: SolicituCustomService,
    private _servicioUsuario: UserService,
    private _serviceProcedimientos: ProcedimientosService,
    private _clientFirmaLog: ClientFirmaLogService,
    private dialog: MatDialog,
    private translate: TranslateService,

    @Inject(LOCALE_ID) public locale: string,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.isAdmin) this.displayedColumns = this.adminColumns.concat((this.displayedColumns));
    this.listadoTramitesService.getTramitesByuserId(this.userId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {

        this.request = data;
        this.request.forEach(tramite =>
          this.tramitesDto.push({
            "Id": tramite.id,
            "Nombre del trámite": tramite.procedimiento_id.nombre,
            "Fecha": new Date(this.formatoFecha(tramite.fechaAlta)),
            "DNI": tramite.usuario_id.numero_documento ?? "",
            "Departamento": tramite.procedimiento_id.departamento.nombre,
            "Estado": EstadoTramiteReturn[tramite.estadoFirma],
            "Acciones": tramite,
            "Finalizado": tramite.estado,
            "Custom": tramite.custom
          }));
        this.dataSource = new MatTableDataSource(this.tramitesDto);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sortingDataAccessor =
          (data: object, sortHeaderId: string): string | number => {
            const propPath = sortHeaderId.split('.');
            const value: any = propPath
              .reduce((curObj, property) => curObj[property], data);
            return !isNaN(value) ? Number(value) : value;
          };
      });
    this.subscription = this._navService.navItem$

      .pipe(takeUntil(this.destroy$))
      .subscribe(item => {
        this.selectedOpcion = item;
        this.downloadJustificanteFrontP();
      });
    this.route.queryParams

      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params["action"] == 30) {
          const rId = params['rId'];
          const accion = params['a'];
          const tramite = params['t'];
          if (rId && accion) {
            this.pdfProcedimientoClave(rId, accion, tramite);
          }
        }
      });
  }
  override ngOnDestroy() {
    super.ngOnDestroy();
  }
  formatoFecha(date) {
    if (date) {
      let month = (date[1] < 10) ? '0' + date[1] : date[1];
      let day = (date[2] < 10) ? '0' + date[2] : date[2];
      let year = date[0];
      let hour = (date[3] < 10) ? '0' + date[3] : date[3];
      let min = (date[4] < 10) ? '0' + date[4] : date[4];
      let seg = (date[5]) ? ((date[5] < 10) ? '0' + date[5] : date[5]) : '00';
      return [year, month, day].join('-').concat('T' + [hour, min, seg].join(':') + '.000Z');
    }
    return ''
  }

  formatDate(date: Date) {
    return formatDate(date, 'dd-MM-yyyy HH:mm', this.locale, 'GMT');
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportarCsv() {
    this.listadoTramitesService.getTramitesForCSV()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.requestCsv = data;
          this._csvgenerate.generateCsvEmvs(this.requestCsv);
        }
      });
  }

  downloadJustificante(idNextcloud: number) {
    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownload.push(idNextcloud);

    this.listadoTramitesService.downloadJustificanteB64(idNextcloud)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (fichero) => {
          const linkSource = 'data:application/pdf;base64,' + fichero.Result;
          const downloadLink = document.createElement("a");
          const fileName = "tramite.pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();

          this._notificationI18n.success('NOTIFICATION.MESSAGE.PDF_DESCARGADO_CON_EXITO', 3000);
          this.isInProgress = false;

          const index: number = this.pdfsDownload.indexOf(idNextcloud);
          this.pdfsDownload.splice(index, 1);
          this.actionProgres = false;
        },
        error: (error) => {
          //console.log(error);
          this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_AL_DESCARGAR_EL_PDF', 3000);

          this.actionProgres = false;
          this.isInProgress = false;
          this.pdfsDownload.splice(this.pdfsDownload.indexOf(idNextcloud), 1);
        }
      });
  }

  downloadJustificanteFront(tramite: any) {
    this.isInProgress = true;
    this.actionProgres = true;
    this.pdfsDownload.push(tramite.id);
    this.idCurrentPdf = tramite.id;

    const resetEstadoFirma = () => {
      this.isInProgress = false;
      this.actionProgres = false;
      const idx = this.pdfsDownload.indexOf(tramite.id);
      if (idx >= 0) this.pdfsDownload.splice(idx, 1);
      this.displayFirma = 'none';
      this.ocultarSpinner();
    };

    if (this.selectedOpcion == 'Firmar con Autofirma') {
      this.mostrarSpinnerMsg('Solicitando firma...')
      this._servicioGeneral.generatePdf(tramite.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (isGeneratePdfReady(data)) {
              this.CSV = data.csv
              this._clientFirmaLog.iniciada(tramite.id, 'listado-tramites-emvs');
              this.singFile(data.file);
            }
            else {
              this._notificationI18n.errorPdfGeneration(data, 5000);
              resetEstadoFirma();
            }
          },
          error: (error) => {
            this._notificationI18n.errorPdfGeneration(error?.error, 5000);
            resetEstadoFirma();
          }
        });
    }
    else {
      this._claveService.iniciaFirma(tramite.id, 1)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async (data: SamlRequest) => {
            this.post(data.nodeService, {
              SAMLRequest: data.SamlRequest,
              RelayState: data.RelayState,
            });
          }, error: (error) => {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_HA_SIDO_POSIBLE_INICIAR_LA_FIRMA_CON_CL_VE', 2000);
            resetEstadoFirma();
          }
        });
    }

  }
  post(path: string, params: any): void {
    let method = "post";
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
  public singFile(data): void {
    try {
      AutoScript.cargarAppAfirma();
      AutoScript.setServlets(Constants.URL_BASE_SERVICES + "/afirma-signature-storage/StorageService",
        Constants.URL_BASE_SERVICES + "/afirma-signature-retriever/RetrieveService");
      AutoScript.sign(
        (data != undefined && data != null && data != "") ? data : null,
        "SHA256withRSA",
        "AUTO",
        "",
        this.successCallback,
        this.showErrorCallback
      );
    } catch (e) {
      this._clientFirmaLog.noDisponible(this.idCurrentPdf, 'listado-tramites-emvs');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.DEBES_DISPONER_DE_LA_APLICACION_AUTOFIRM_PARA_FIRMAR_LOS_TRAMITES_ADMINISTRATIVO')
    }
  }

  public successCallback = (filenameB64, certB64): void => {
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    // filenameB64 es el nombre del fichero de firma codificado en Base 64
    (document.getElementById('certifcado') as HTMLInputElement).value = certB64;
    (document.getElementById('result') as HTMLInputElement).value = filenameB64;
    (document.getElementById('error') as HTMLInputElement).value = '';
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }

  public showErrorCallback = (errorType, errorMessage): void => {
    logAutofirmaError(this._clientFirmaLog, this.idCurrentPdf, 'listado-tramites-emvs', errorType, errorMessage);
    if (isFirmaSubmitLocked(this)) {
      releaseFirmaSubmitLock(this);
      return;
    }
    (document.getElementById('certifcado') as HTMLInputElement).value = '';
    (document.getElementById('result') as HTMLInputElement).value = '';
    (document.getElementById('error') as HTMLInputElement).value = errorMessage + ". Se ha habilitado la opción para firmar con Cl@ve";
    document.forms["firma"].dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }


  resultchange(event: Event): void {
    event.preventDefault();
    if (isFirmaSubmitLocked(this)) {
      return;
    }
    this.firmaResultLocked = true;
    this.ocultarSpinner()
    let base64Document = (document.getElementById('result') as HTMLInputElement).value;
    let errorFirma = (document.getElementById('error') as HTMLInputElement).value;

    if ((errorFirma == '' && base64Document != '')) {
      this.mostrarSpinnerMsg('Subiendo documentos firmados...')
      let certificado = atob((document.getElementById('certifcado') as HTMLInputElement).value);
      if (certificado.includes(this.tokenStorageService.getUser().numero_documento)) {
        this._clientFirmaLog.exito(this.idCurrentPdf, 'listado-tramites-emvs');
        this.listadoTramitesService.updateJustificanteB64({ 'b64Document': base64Document, 'id': this.idCurrentPdf, csv: this.CSV })
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (value) => {
              this._clientFirmaLog.subidaOk(this.idCurrentPdf, 'listado-tramites-emvs');
              this._serviceProcedimientos
                .getProcedimientoByIdTramite(value.tramite?.id)

                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (procedimiento: any) => {
                    if (procedimiento?.Procedimiento?.id && procedimiento?.Procedimiento?.id != 2)
                      this.downloadPdf(base64Document, 'comprobante_solicitud_tramite');
                  },
                  error: (error) => {
                  },
                });
              releaseFirmaSubmitLock(this);
              this.isInProgress = false;
              this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
              this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_PDF_SE_HA_FIRMADO_CON_EXITO');
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
              this.displayFirma = 'none';
              this._router.navigate(['/inicio'], { skipLocationChange: true }).then(() => { this._router.navigate(['/perfil'], { queryParams: { action: 30 } }); this.ocultarSpinner() });
            },
            error: (err) => {
              console.error(err);
              releaseFirmaSubmitLock(this);
              this._clientFirmaLog.subidaError(this.idCurrentPdf, 'listado-tramites-emvs', err?.message);
              this.actionProgres = false;
              this.isInProgress = false;
              this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
              this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_SUBIR');
              this.displayFirma = 'none';
              this.ocultarSpinner()

            },
          });
      } else {
        releaseFirmaSubmitLock(this);
        this._clientFirmaLog.certificadoInvalido(this.idCurrentPdf, 'listado-tramites-emvs');
        this.actionProgres = false;
        this.isInProgress = false;
        this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
        this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_EL_CERTIFICADO_NO_COINCIDE_CON_EL_USUARIO');
        this.ocultarSpinner()
      }

    } else {
      releaseFirmaSubmitLock(this);
      this._clientFirmaLog.error(this.idCurrentPdf, 'listado-tramites-emvs', undefined, errorFirma || 'Firma cancelada o fallida');
      this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_PDF_NO_SE_HA_PODIDO_FIRMAR_POR_FAVOR_COMPRUEBE_QUE_NO_DISPONE_DE_NINGUN_BLOQU');
      this.isInProgress = false;
      this.actionProgres = false;
      this._servicioUsuario
        .clearCurrentTipoFirma()

        .pipe(takeUntil(this.destroy$))
        .subscribe(() => { });
      this.pdfsDownload.splice(this.pdfsDownload.indexOf(this.idCurrentPdf), 1);
    }
  }

  resumeTramite(tramiteIn: any) {
    const tramite = this.request.find(a => a.id == tramiteIn.Id);
    const estadoFirma = tramiteIn?.['Acciones']?.estadoFirma ?? tramite?.estadoFirma;
    if (bloquearSiTramiteDadoDeBaja(estadoFirma, this._router, this._notificationI18n)) {
      return;
    }
    const procId = tramite?.procedimiento_id?.id ?? tramiteIn?.procedimiento_id?.id;
    if (!procId) {
      if (bloquearSiProcedimientoNoActivo(null, this._router, this._notificationI18n, this.user)) {
        return;
      }
      return;
    }
    this._serviceProcedimientos.getProcedimiento(procId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (procedimiento) => {
          if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.user)) {
            return;
          }
          if (tramiteIn.Custom) {
            this._router.navigateByUrl('/formulario/' + procId);
          } else {
            this.checkNoExisteTramite(tramite);
          }
        },
        error: () => {
          bloquearSiProcedimientoNoActivo(null, this._router, this._notificationI18n, this.user);
        },
      });
  }
  checkNoExisteTramite(tramiteIn: any) {
    if (tramiteIn.procedimiento_id.id == 2) {
      this.mostrarSpinnerMsg('Revisando su solicitud');
      this.listadoTramitesService.checkDoesntExistRpsv()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.ocultarSpinner();
            if (!value) {
              this._notificationI18n.warning('NOTIFICATION.MESSAGE.YA_FIGURAN_SUS_DATOS_EN_UNA_SOLICITUD_RPSV_NO_ES_POSIBLE_DAR_DE_ALTA_NUEVAMENTE_');
            }
            else {
              this.listadoTramitesService.tramite = tramiteIn
              this._router.navigateByUrl(tramiteIn.procedimiento_id.link_path + '/' + tramiteIn.procedimiento_id.id);
            }
          },
          error: (err) => {
            this.ocultarSpinner();
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.HA_OCURRIDO_UN_ERROR_VALIDANDO_LA_EXISTENCIA_DE_UN_TRAMITE_PREVIO_DE_TIPO_RPSV');
          },
        });
    } else {
      this.listadoTramitesService.tramite = tramiteIn
      this._router.navigateByUrl(tramiteIn.procedimiento_id.link_path + '/' + tramiteIn.procedimiento_id.id);
    }

  }
  deleteTramite(tramite: TramiteEmvs) {
    if (bloquearSiTramiteDadoDeBaja(tramite?.estadoFirma, this._router, this._notificationI18n)) {
      return;
    }
    this.deleteCurrenTramite = tramite;
    const nombre = tramite?.procedimiento_id?.nombre || '';
    const ref = this.dialog.open(ConfirmDeleteDialogComponent, {
      data: {
        title: 'Eliminar trámite',
        message: `¿Seguro que quieres eliminar el trámite «${nombre}»? El trámite quedará dado de baja.`,
        confirmLabel: 'Eliminar'
      },
      panelClass: 'gu-dialog-panel'
    });
    ref.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((ok) => {
        if (!ok) return;
        this.confirmDelete();
      });
  }

  registrarTramite(tramite: TramiteEmvs) {
    if (bloquearSiTramiteDadoDeBaja(tramite?.estadoFirma, this._router, this._notificationI18n)) {
      return;
    }
    tramite.estadoFirma = EstadoTramite.FIRMADO_CON_REGISTRO;
    tramite.procedimiento_id = { id: tramite.procedimiento_id.id }
    tramite.fechaAlta = null;
    tramite.fechaModificacion = null;
    this.actionProgres = true;
    if (!tramite.custom) {
      this._solicitudEmvsService.updateEstadoTramite(tramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            if (value.estadoFirma == 'FIRMADO_CON_REGISTRO') {
              this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_REGISTRADO_CON_EXITO');
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            } else if (value.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
              this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_PENDIENTE_AUTORIZADOS', 5000);
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            } else {
              this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_CONTACTAR_CON_EL_SERVICIO_DE_REGISTRO_INTENTELO_DE_NUEVO_MAS_TARDE');
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            }

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_REGISTRAR');
            this.actionProgres = false;
          },
        })
    } else {
      let tramiteIn: any = {
        IdTramite: tramite.id
      };
      this._solicituCustomService.updateEstadoTramite(tramiteIn)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            if (value.estadoFirma == 'FIRMADO_CON_REGISTRO') {
              this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_REGISTRADO_CON_EXITO');
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            } else {
              this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_CONTACTAR_CON_EL_SERVICIO_DE_REGISTRO_INTENTELO_DE_NUEVO_MAS_TARDE');
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            }

          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_REGISTRAR');
            this.actionProgres = false;
          },
        })
    }
  }

  confirmDelete() {
    if (this.deleteCurrenTramite.custom) {

      this.listadoTramitesService.deleteTramiteFormCustom(this.deleteCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }
    else {
      this.listadoTramitesService.deleteTramiteForm(this.deleteCurrenTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_TRAMITE_SE_HA_ELIMINADO_CON_EXITO');
            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
          },
          error: (err) => {
            console.error(err);
            this._notificationI18n.error('NOTIFICATION.MESSAGE.EL_TRAMITE_NO_SE_HA_PODIDO_ELIMINAR');
          },
        })
    }

  }

  public downloadPdf(base64Document, fileName) {
    const source = 'data:application/pdf;base64,' + base64Document;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}.pdf`
    link.click();
  }

  public valuesEnum(object): boolean {
    return Object.values(this.estadoTramiteReturn).includes(object)
  }

  public getEstadoLabel(row: TramiteDto): string {
    const acciones = row?.['Acciones'] as { estadoFirma?: string } | undefined;
    const estadoFirma = acciones?.estadoFirma;
    if (!estadoFirma) {
      return row?.['Estado'] ?? '';
    }
    const key = `TRAMITE_LIST.STATUS.${estadoFirma}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : (row?.['Estado'] ?? '');
  }

  public getEstadoTipo(row: any): 'completado' | 'pendiente' | 'rechazado' | '' {
    const estado = row?.['Acciones']?.estadoFirma;
    switch (estado) {
      case 'FIRMADO_CON_REGISTRO':
      case 'FIRMADO_BAJA_USUARIO':
        return 'completado';
      case 'NO_FINALIZADO':
      case 'FIRMADO_SIN_REGISTRO':
      case 'PENDIENTE_DE_FIRMA':
      case 'PROCESANDO':
      case 'PENDIENTE_DE_FIRMA_AUTORIZADOS':
        return 'pendiente';
      case 'DADO_BAJA_AUTOMATICA':
      case 'DADO_BAJA_FIN_PROCEDIMIENTO':
      case 'ANULADO_POR_FIRMANTE':
      case 'RECHAZADA':
      case 'RECHAZADO_UNIDAD_FAMILIAR':
      case 'DADO_BAJA_USUARIO':
        return 'rechazado';
      default:
        return 'pendiente';
    }
  }

  signTramite(tramite: any) {
    if (bloquearSiTramiteDadoDeBaja(tramite?.estadoFirma, this._router, this._notificationI18n)) {
      return;
    }
    this.displayFirma = 'block';
    this.selectedTramite = tramite;
  }
  downloadJustificanteFrontP() {
    if (this.selectedTramite && this.displayFirma == 'block') this.downloadJustificanteFront(this.selectedTramite);
  }

  public pdfProcedimientoClave(rId: string, accion: string, tramite: string) {
    if (accion == 'firmar' && rId && tramite) {
      this.actionProgres = true;
      this._claveService.getResultFirma(rId)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data: any) => {
            if (data.status && data.status == '658') {
              this.listadoTramitesService.getTramiteById(Number(tramite))
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                  next: (data: any) => {
                    this._solicitudEmvsService.updateEstadoTramiteById(data.id)
                      .pipe(takeUntil(this.destroy$))
                      .subscribe({
                        next: (data: any) => {
                          if (data.estadoFirma == 'FIRMADO_CON_REGISTRO') {
                            this.downloadPdf(data.pdfFirmado, 'comprobante_solicitud_tramite');
                            this.actionProgres = false;
                            this._notificationI18n.success('NOTIFICATION.MESSAGE.EL_PDF_SE_HA_FIRMADO_CON_EXITO_Y_EL_TRAMITE_SE_HA_REGISTRADO_CON_EXITO');
                            this.limpiarParametros();
                            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                          } else if (data.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
                            this.actionProgres = false;
                            this._notificationI18n.success('NOTIFICATION.MESSAGE.LOS_MIEMBROS_DE_UNIDAD_FAMILIAR_MAYORES_DE_18_TENDRAN_QUE_GESTIONAR_LA_AUTORIZAC');
                            this.limpiarParametros();
                            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                          }
                          else {
                            this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_CONTACTAR_CON_EL_SERVICIO_DE_REGISTRO_INTENTELO_DE_NUEVO_MAS_TARDE');
                            this.limpiarParametros();
                            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                            this.actionProgres = false;
                          }
                        },
                        error: (error) => {
                          this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_PUDO_CONTACTAR_CON_EL_SERVICIO_DE_REGISTRO_INTENTELO_DE_NUEVO_MAS_TARDE');
                          this.limpiarParametros();
                          this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                          this.actionProgres = false;
                        }
                      });
                  },
                  error: (error) => {
                    this._notificationI18n.warning('NOTIFICATION.MESSAGE.NO_SE_HA_ENCONTRADO_EL_TRAMITE_A_FIRMAR');
                    this.limpiarParametros();
                    this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
                    this.actionProgres = false;
                  }
                });
            }
            else {
              this._notificationI18n.warning('NOTIFICATION.MESSAGE.EL_IDENTIFICADOR_DE_AUTENTICACION_NO_ES_VALIDO_INTENTELO_DE_NUEVO_MAS_TARDE');
              this.limpiarParametros();
              this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
              this.actionProgres = false;
            }
          },
          error: (error) => {
            this._notificationI18n.warning('NOTIFICATION.MESSAGE.HA_OCURRIDO_UN_ERROR_VALIDANDO_EL_IDENTIFICADOR_DE_AUTENTICACION_INTENTELO_DE_NU');
            this.limpiarParametros();
            this._boardAdmin.reloadComponent = !this._boardAdmin.reloadComponent;
            this.actionProgres = false;
          }

        });
    }
  }
  limpiarParametros() {
    this._router.navigate([], {
      queryParams: {
        'rId': null,
        'a': null,
        't': null,
      },
      queryParamsHandling: 'merge'
    });
  }
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('litado_tramites_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('litado_tramites_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('litado_tramites_spinner');
  }
}